import { useState } from "react";
import { LockKeyhole } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export const AdminLogin = () => {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await login(form.email, form.password);
      if (user.role !== "admin") setError("This account does not have admin access.");
    } catch (err) {
      setError(apiError(err.response?.data?.detail, err.message));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 px-6" data-testid="admin-login-page">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-slate-200 rounded-lg shadow-sm p-8 space-y-5"
      >
        <div className="flex items-center gap-3">
          <LockKeyhole className="w-5 h-5 text-blue-900" />
          <h1 className="text-xl font-medium text-slate-900">Clinic Staff Login</h1>
        </div>
        <p className="text-sm text-slate-500">Nidaan Dental Care admin panel</p>
        <div className="space-y-2">
          <Label htmlFor="admin-email">Email</Label>
          <Input
            id="admin-email"
            type="email"
            required
            value={form.email}
            data-testid="admin-email-input"
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="rounded-md h-11"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="admin-password">Password</Label>
          <Input
            id="admin-password"
            type="password"
            required
            value={form.password}
            data-testid="admin-password-input"
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="rounded-md h-11"
          />
        </div>
        {error && (
          <p className="text-sm text-red-600" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <Button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="w-full h-11 rounded-md bg-blue-900 text-white hover:bg-blue-950 hover:text-white"
        >
          {busy ? "Signing in…" : "Sign In"}
        </Button>
      </form>
    </div>
  );
};
